import { defineTranslateKeys } from 'lib/tolgee'

export default defineTranslateKeys({
  territoryInSearch: {
    key: 'TerritoryInSearch-in',
    defaultValue: 'in',
  },
})
